import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const PrivacyRemovalConfirmation = () => {    
    const APP_URL = window.site_url;
    const { id } = useParams(); // Fetch the ID from the route parameters
    const navigate = useNavigate();

    useEffect(() => {
        const confirmRemoval = async () => {
            try {
                const response = await axios.get(`${APP_URL}/api/data-removal-lead/removalConfirmation/${id}`);                
                const message = response.data.message;            
                if (response.status === 200) {                    
                    navigate('/thank-you', { state: { message, fromSubmission: true } });
                } else {                                    
                    navigate('/accessdenied', { state: { message, fromSubmission: true } });
                }
            } catch (error) {
                const serverMessage = error.response?.data?.message || "An unexpected error occurred.";
            
                navigate('/accessdenied', { state: { message: serverMessage , fromSubmission: true } });
            }
        };

        confirmRemoval();
    }, [id, navigate]);

    return null; // No loading message displayed while processing
};

export default PrivacyRemovalConfirmation;
